import * as angular from 'angular';
import template from './selectResetOption.tpl.html';

export function openSelectResetOption($modal: mm.foundation.modal): angular.IPromise<any> {
  return $modal.open({
    template: template,
    controller: 'SelectResetOptionCtrl as vm'
  }).result;
}

class SelectResetOptionCtrl {
  private instance: mm.foundation.modalInstance;

  constructor($modalInstance: mm.foundation.modalInstance) {
    this.instance = $modalInstance;
  }

  question() {
    this.instance.close({question: true});
  }

  email() {
    this.instance.close({email: true});
  }

  close() {
    this.instance.close();
  }
}

export default angular.module('aps.controller.selectResetOption', [])
  .controller('SelectResetOptionCtrl', SelectResetOptionCtrl)
  .name;



// WEBPACK FOOTER //
// ./src/app/controllers/signIn/selectResetOption.ts